import FondationsServiceModel from '@/models/FondationsServiceModel';

export default class UserMediaProfilePictureModel extends FondationsServiceModel {
	static get path(): string {
		return '/user_media_profile_pictures';
	}

	public get iri(): string {
		return this.get('iri', '');
	}

	public upload(blob: Blob, options: object = {}) {
		return new Promise((resolve, reject) => {
			const formData = new FormData();
			formData.append('file', blob);
			return this.connector.save(this, {...options, patchAttributes: formData}).then(
				(result) => {
					this.onSaveSuccess(result, options);
					resolve(this);
				}
			).catch((err) => reject(err));
		});
	}
}
